export const CONTACT = {
  phone: "+351963314690",
  phoneDisplay: "+351 963 314 690",
  whatsappNumber: "351963314690",
  mapsUrl:
    "https://www.google.com/maps/place/Monte+Sol+Stone+steak+House/@37.0904823,-8.1181011,20z/data=!4m6!3m5!1s0xd1ab5e98a966cbd:0x92f19c02b231ef13!8m2!3d37.0904823!4d-8.1175378!16s%2Fg%2F11cn12swym",
  addressLine: "Monte Sol, Caminho das Alfarrobeiras",
  addressPostal: "8125-414 Quarteira, Portugal",
  mapsEmbed:
    "https://maps.google.com/maps?q=Monte%20Sol%20Stone%20steak%20House%20Vilamoura&t=&z=17&ie=UTF8&iwloc=&output=embed",
  agencyUrl: "https://solucoesromanas.pt",
  facebookUrl: "https://www.facebook.com/profile.php?id=100090644933250",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_sol-premium-dining/artifacts/f21h3lq4_Logo-Monte-Sol-Vilamoura.png",
};

export const buildWhatsAppLink = (message) => {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${CONTACT.whatsappNumber}?text=${encoded}`;
};
